const BlockTitle = ({ text, style }) => (
	<div>
		<span
			style={{
				fontSize: '1.02rem',
				fontWeight: 'bold',
				...style
			}}
		>
			{text}
		</span>
	</div>
);

export default BlockTitle;
